export default class AppRegistryLoader {
  static async load(fn) {
    // `defer` packs can execute after DOMContentLoaded has already fired, in which case
    // this listener would never run and `fn` would silently never be called. Run
    // immediately once the DOM is parsed instead of waiting for an event that already
    // happened.
    if (document.readyState !== "loading") {
      return fn();
    }

    return new Promise(resolve => {
      document.addEventListener("DOMContentLoaded", async () => {
        await fn();
        resolve();
      });
    });
  }
}
